import { createReduxModule } from '@skippay/core/utils/reduxUtils';

import { MODULE_NAME } from './constants';
import reducer from './reducer';
import sagas from './sagas';

export * from './actions';
export * from './constants';
export * from './selectors';
export * from './utils';
export { default as useScreenMinWidth } from './useScreenMinWidth';

export default createReduxModule(MODULE_NAME, reducer, sagas);
